import { isBrowser } from './window';

const config = {
  production: {
    SENTRY_ENDPOINT:
      'https://937924b432154737854ac81825b36cf8@sentry.io/1779871',
    APOLLO_ENDPOINT: 'https://colugo.vytal.org',
    STRIPE_PUBLIC_KEY:
      'pk_live_51GzKl9LPQ6sF4MhE419TPTzXpBNwLObKXCw1m925T9CQ85EtptfjpE4QNbQTnZSeg4MMb3g3AtJjzfuhbuqrzmVG003M2yaIsD',
    AUTH0_DOMAIN: 'b2g.eu.auth0.com',
    AUTH0_CLIENTID: 'AfgHBSGgkgY6NnD6zvw6Yi-3HbdNCHkt',
    UPLOAD_URL: 'https://colugo.vytal.org/requestUploadURL',
    GA_ID: 'UA-154163118-1',
    STAGE: 'PROD',
    PARTICIPATING_EVENT_ACCOUNT_SYNC_ENABLED: true,
    // GOOGLE_MAP_KEY: 'AIzaSyDm0ACk0sMZsL9MGBvITQK2c-AvrZQHZo8',
    // GOOGLE_MAP_URL: 'https://maps.googleapis.com/maps/api/directions/json?',
    // APPLE_PAY_MERCHANT_ID: 'merchant.de.pickpack',
    // GOOGLE_PAY_MERCHANT_ID: '15192999776129618742',
  },
  development: {
    SENTRY_ENDPOINT:
      'https://937924b432154737854ac81825b36cf8@sentry.io/1779871',
    APOLLO_ENDPOINT: 'https://colugo-dev.vytal.org',
    STRIPE_PUBLIC_KEY:
      'pk_test_51GzKl9LPQ6sF4MhElssoWtebJdlb4JzTEKKMFbPgGKl96qguyRt6TUeUi2VwObTRGRYkHtga6e5BxP7fyLlPEdpf00ulPckIo2',
    AUTH0_DOMAIN: 'b2g.eu.auth0.com',
    AUTH0_CLIENTID: 'AfgHBSGgkgY6NnD6zvw6Yi-3HbdNCHkt',
    UPLOAD_URL: 'https://colugo-dev.vytal.org/requestUploadURL',
    GA_ID: 'UA-154163118-1',
    STAGE: 'DEV',
    PARTICIPATING_EVENT_ACCOUNT_SYNC_ENABLED: true,
    // GOOGLE_MAP_KEY: 'AIzaSyDm0ACk0sMZsL9MGBvITQK2c-AvrZQHZo8',
    // GOOGLE_MAP_URL: 'https://maps.googleapis.com/maps/api/directions/json?',
    // APPLE_PAY_MERCHANT_ID: 'merchant.de.pickpack',
    // GOOGLE_PAY_MERCHANT_ID: '15192999776129618742',
  },

  // not used right now
  localDevelopment: {
    APOLLO_ENDPOINT: 'http://localhost:3000',
    STRIPE_PUBLIC_KEY: 'pk_test_R7QuectOQ5mvpCYKYZm1EBta',
    AUTH0_DOMAIN: 'b2g.eu.auth0.com',
    AUTH0_CLIENTID: 'AfgHBSGgkgY6NnD6zvw6Yi-3HbdNCHkt',
    UPLOAD_URL: 'https://colugo-dev.vytal.org/new/requestUploadURL',
    GA_ID: 'UA-154163118-1',
    STAGE: 'DEV',
    // GOOGLE_MAP_KEY: 'AIzaSyDm0ACk0sMZsL9MGBvITQK2c-AvrZQHZo8',
    // GOOGLE_MAP_URL: 'https://maps.googleapis.com/maps/api/directions/json?',
    // APPLE_PAY_MERCHANT_ID: 'merchant.de.pickpack',
    // GOOGLE_PAY_MERCHANT_ID: '15192999776129618742',
  },
};

const isProduction =
  isBrowser &&
  ['appadmin.vytal.org', 'partner.vytal.org'].includes(window.location.host);
window._isProd = isProduction;

export const AppConfig = isProduction ? config.production : config.development;
